import { HeaderConfig } from "./headerUtils";
import { createAxiosInstance } from "../config/apiConfig";
import { handleApiError, ErrorHandler } from "./errorUtils";
import { generateHeaders } from "./headerUtils";
import { AxiosRequestHeaders } from "axios";
import { createApiController } from "../../utilities/Helpers";
import { messages } from "../../../src/resources/strings";
import { store } from "../../store/Store";

export const apiGet = async <T>(
  service: number,
  endpoint: string,
  headerConfig?: HeaderConfig,
  params?: Record<string, any>,
  errorHandlers?: ErrorHandler[],
): Promise<any> => {
  try {
    if (store.getState().userReducer.isConnected === false) {
      return handleApiError(messages.error.networkError, errorHandlers);
    }
    const controller = createApiController();
    const headers = await generateHeaders(headerConfig);
    const api = createAxiosInstance(service);

    let reqObj: any = {
      headers,
      params,
    };
    if (headerConfig?.isSignalAbortAllowed) {
      reqObj.signal = controller.signal;
    }
    const response = await api.get(endpoint, reqObj);

    return response?.data;
  } catch (error) {
    return handleApiError(error, errorHandlers);
  }
};

export const apiPost = async (
  service: number,
  endpoint: string,
  data: any,
  headerConfig?: HeaderConfig,
  errorHandlers?: ErrorHandler[],
  headersData?: AxiosRequestHeaders,
  params?: Record<string, any>,
): Promise<any> => {
  try {
    if (store.getState().userReducer.isConnected === false) {
      return handleApiError(messages.error.networkError, errorHandlers);
    }
    const headers = await generateHeaders(headerConfig);
    const api = createAxiosInstance(service);
    let reqObj: any = {
      headers: headersData ?? headers,
    };
    if (params) {
      reqObj.params = params;
    }
    const response = await api.post(endpoint, data, reqObj);
    return response;
  } catch (error) {
    return handleApiError(error, errorHandlers);
  }
};

export const apiPatch = async (
  service: number,
  endpoint: string,
  data: any,
  headerConfig?: HeaderConfig,
  errorHandlers?: ErrorHandler[],
  headersData?: AxiosRequestHeaders,
): Promise<any> => {
  try {
    if (store.getState().userReducer.isConnected === false) {
      return handleApiError(messages.error.networkError, errorHandlers);
    }
    const headers = await generateHeaders(headerConfig);
    const api = createAxiosInstance(service);
    const response = await api.patch(endpoint, data, {
      headers: headersData ?? headers,
    });
    return response;
  } catch (error) {
    return handleApiError(error, errorHandlers);
  }
};

export const apiPut = async (
  service: number,
  endpoint: string,
  data: any,
  headerConfig?: HeaderConfig,
  errorHandlers?: ErrorHandler[],
  headersData?: AxiosRequestHeaders,
): Promise<any> => {
  try {
    if (store.getState().userReducer.isConnected === false) {
      return handleApiError(messages.error.networkError, errorHandlers);
    }
    const headers = await generateHeaders(headerConfig);
    const api = createAxiosInstance(service);
    const response = await api.put(endpoint, data, {
      headers: headersData ?? headers,
    });
    return response;
  } catch (error) {
    return handleApiError(error, errorHandlers);
  }
};
